import React from 'react';
import { connect } from 'react-redux';
import styles from './RequestHelp.module.css'
import { helpCenterActions } from '_actions';
import { bindActionCreators } from 'redux';
class Locations extends React.Component {

    componentDidMount() {
        const companyId = sessionStorage.getItem('companyId');
        if(companyId !== null && companyId !== undefined)
        {
            const user = JSON.parse(localStorage.getItem(`user_${companyId}`));
            if(user?.urno !== undefined && user?.urno !== null)
                this.props.getLocations(user?.urno);
        }
      
    }

    render() {
        let row = 0;
        return (
            <div>
                <div className={styles.header}>Locations with wifi codes</div>
                <div className={styles.wrapper}>
                    <span className={styles.col1} />
                    <span className={styles.col2}>
                        {Object.keys(this.props.locations)
                            .map(id => {
                                const loc = this.props.locations[id];
                                row++;
                                return (
                                    <div className={row % 2 === 0 ? styles.contact_wrapper : styles.contact_wrapper_odd} key={loc.lcid}>
                                        <span className={styles.contact_name}>{loc.lcid}</span>
                                        <span className={styles.contact_number}>{loc.lcwificode}</span>
                                    </div>
                                );
                            })
                        }
                    </span>
                    <span className={styles.col3} />
                    <span className={styles.col4} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        locations: state.ui.helpCenter.locations
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getLocations: bindActionCreators(helpCenterActions.getLocations, dispatch)
    };
}


const connectedLocations = connect(mapStateToProps, mapDispatchToProps)(Locations);
export { connectedLocations as Locations }
